import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import ContentListItem from "../../ContentListItem";
import { RouterListItem } from "@ploy-ui/core";
import { ApplicationInfoResource, useResourceWithInvalidate } from "@ploy-lib/rest-resources";
import { Divider } from "@material-ui/core";
import { useIntl } from "react-intl";
export function TaskListItem(props) {
    const { id, name, filter, applicationsSearchPath, setApplicationsSearchParams, primaryMessage, secondaryMessage, showEmptyResult, ...rest } = props;
    const results = useResourceWithInvalidate(ApplicationInfoResource.list(), {
        ...filter,
        pageSize: 1
    });
    const intl = useIntl();
    const formatMessage = intl.formatMessage;
    const messages = {
        primary: primaryMessage
            ? formatMessage({ id: primaryMessage, defaultMessage: primaryMessage }, { amount: results.recordCount })
            : primaryMessage,
        secondary: secondaryMessage
            ? formatMessage({ id: secondaryMessage, defaultMessage: secondaryMessage }, { amount: results.recordCount })
            : secondaryMessage
    };
    const onClick = setApplicationsSearchParams && (() => setApplicationsSearchParams(filter));
    if (results.recordCount <= 0 && !showEmptyResult)
        return null;
    let listItem = _jsx(ContentListItem, { ...messages, ...rest });
    if (onClick)
        listItem = (_jsx(ContentListItem, { ...messages, ...rest, onClick: onClick, button: true }));
    if (applicationsSearchPath)
        listItem = (_jsx(ContentListItem, { ...messages, ...rest, onClick: onClick, button: true, component: RouterListItem, to: applicationsSearchPath }));
    return (_jsxs(_Fragment, { children: [listItem, _jsx(Divider, {})] }));
}
//# sourceMappingURL=TaskListItem.js.map